import i18n from "i18next";

import type { MedicalNoteType } from "types/MedicalNoteConfig";

export function translateMedicalNoteType(noteType: MedicalNoteType): string {
  const keyMap: Record<MedicalNoteType, string> = {
    APPOINTMENT: i18n.t("dashboard.tables.notes.types.APPOINTMENT"),
    CHAT: i18n.t("dashboard.tables.notes.types.CHAT"),
    DIAGNOSIS_THERAPIST: i18n.t("dashboard.tables.notes.types.DIAGNOSIS_THERAPIST"),
    DISCHARGE: i18n.t("dashboard.tables.notes.types.DISCHARGE"),
    DISCHARGE_TO_SELFCARE: i18n.t("dashboard.tables.notes.types.DISCHARGE_TO_SELFCARE"),
    PROGRESS: i18n.t("dashboard.tables.notes.types.PROGRESS"),
    PROTOCOL_DISCHARGE: i18n.t("dashboard.tables.notes.types.PROTOCOL_DISCHARGE"),
    PROTOCOL_MONTHLY: i18n.t("dashboard.tables.notes.types.PROTOCOL_MONTHLY"),
    PROTOCOL_QUARTERLY: i18n.t("dashboard.tables.notes.types.PROTOCOL_QUARTERLY"),
    PROTOCOL_WEEKLY: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY"),
    PROTOCOL_WEEKLY_W0: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W0"),
    PROTOCOL_WEEKLY_W10: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W10"),
    PROTOCOL_WEEKLY_W11: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W11"),
    PROTOCOL_WEEKLY_W11_AND_W12: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W11_AND_W12"),
    PROTOCOL_WEEKLY_W12: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W12"),
    PROTOCOL_WEEKLY_W13: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W13"),
    PROTOCOL_WEEKLY_W14: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W14"),
    PROTOCOL_WEEKLY_W15: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W15"),
    PROTOCOL_WEEKLY_W16: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W16"),
    PROTOCOL_WEEKLY_W17: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W17"),
    PROTOCOL_WEEKLY_W18: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W18"),
    PROTOCOL_WEEKLY_W19: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W19"),
    PROTOCOL_WEEKLY_W20: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W20"),
    PROTOCOL_WEEKLY_W2: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W2"),
    PROTOCOL_WEEKLY_W3: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W3"),
    PROTOCOL_WEEKLY_W4: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W4"),
    PROTOCOL_WEEKLY_W5: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W5"),
    PROTOCOL_WEEKLY_W6: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W6"),
    PROTOCOL_WEEKLY_W7: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W7"),
    PROTOCOL_WEEKLY_W7_AND_W8: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W7_AND_W8"),
    PROTOCOL_WEEKLY_W8: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W8"),
    PROTOCOL_WEEKLY_W9: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W9"),
    PROTOCOL_WEEKLY_W9_AND_W10: i18n.t("dashboard.tables.notes.types.PROTOCOL_WEEKLY_W9_AND_W10"),
    RE_EVALUATION: i18n.t("dashboard.tables.notes.types.RE_EVALUATION"),
    RTM_ADDITIONAL: i18n.t("dashboard.tables.notes.types.RTM_ADDITIONAL"),
    RTM_ADHERENCE: i18n.t("dashboard.tables.notes.types.RTM_ADHERENCE"),
    RTM_FIRST: i18n.t("dashboard.tables.notes.types.RTM_FIRST"),
    RTM_INITIAL: i18n.t("dashboard.tables.notes.types.RTM_INITIAL"),
    SUPPLEMENTAL: i18n.t("dashboard.tables.notes.types.SUPPLEMENTAL"),
    TREATMENT: i18n.t("dashboard.tables.notes.types.TREATMENT"),
    TREATMENT_AND_PROGRESS: i18n.t("dashboard.tables.notes.types.TREATMENT_AND_PROGRESS"),
    UNLOCKING_THERAPIST: i18n.t("dashboard.tables.notes.types.UNLOCKING_THERAPIST"),
    PHYSICAL_VISIT_NEW: i18n.t("dashboard.tables.notes.types.PHYSICAL_VISIT_NEW"),
    PHYSICAL_VISIT_RETURN: i18n.t("dashboard.tables.notes.types.PHYSICAL_VISIT_RETURN"),
    DEFAULT: "",
    INITIAL_HYBRID: i18n.t("dashboard.tables.notes.types.INITIAL_HYBRID"),
    CHAT_HYBRID: i18n.t("dashboard.tables.notes.types.CHAT_HYBRID"),
    CHAT_FOLLOW_UP: i18n.t("dashboard.tables.notes.types.CHAT_FOLLOW_UP"),
    PHYSICIAN_MEDICAL_REFERRAL: i18n.t("dashboard.tables.notes.types.PHYSICIAN_MEDICAL_REFERRAL"),
    PHYSICIAN_PLAN_OF_CARE: i18n.t("dashboard.tables.notes.types.PHYSICIAN_PLAN_OF_CARE"),
    CALL_HYBRID: i18n.t("dashboard.tables.notes.types.CALL_HYBRID"),
    INITIAL_RE_EVAL: i18n.t("dashboard.tables.notes.types.INITIAL_RE_EVAL"),
    INITIAL_EVAL: i18n.t("dashboard.tables.notes.types.INITIAL_EVAL"),
  };

  return keyMap[noteType] || noteType;
}
